import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderByPriority',
})
export class OrderByPriorityPipe implements PipeTransform {
  // nnkitodo [v2later] utiliser ce pipe partout plutôt que de faire le sort sur l'entité
  transform(value: any[]): any[] {
    return value.sort((a, b) => a.priority - b.priority);
  }
}
